// SideBar.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SideBar.css';
import pinLogo from './assets/pinlogo.png';

function SideBar({ isOpen, toggleSidebar }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') toggleSidebar();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [toggleSidebar]);

  // Assuming these refs and state are declared somewhere above or need to be declared:
  // Adding them here for completeness:
  const [dragX, setDragX] = React.useState(0);
  const [isDragging, setIsDragging] = React.useState(false);
  const startXRef = React.useRef(0);
  const startTranslateRef = React.useRef(0);

  const getDrawerWidth = () => {
    if (typeof window === 'undefined') return 0;
    const el = document.querySelector('.sidebar-container');
    return el ? el.offsetWidth : 0;
  };

  // Touch fallback (some mobile browsers behave better with touch events)
  const onTouchStart = (e) => {
    if (!isOpen) return;
    const t = e.touches && e.touches[0];
    if (!t) return;

    startXRef.current = t.clientX;
    startTranslateRef.current = dragX;
    setIsDragging(true);
  };

  const onTouchMove = (e) => {
    if (!isOpen) return;
    if (!isDragging) return;

    const t = e.touches && e.touches[0];
    if (!t) return;

    const w = getDrawerWidth();
    if (!w) return;

    const delta = t.clientX - startXRef.current;
    const next = Math.min(0, startTranslateRef.current + delta);
    const clamped = Math.max(-w, next);

    setDragX(clamped);
  };

  const onTouchEnd = () => {
    if (!isOpen) return;
    if (!isDragging) return;

    const w = getDrawerWidth();
    const closeThreshold = w * 0.35;
    const shouldClose = Math.abs(dragX) > closeThreshold;

    setIsDragging(false);

    if (shouldClose) {
      setDragX(-w);
      window.setTimeout(() => {
        toggleSidebar();
        setDragX(0);
      }, 180);
    } else {
      setDragX(0);
    }
  };

  return (
    <>
      <div
        className={`sidebar-overlay ${isOpen ? 'visible' : ''}`}
        onClick={toggleSidebar}
      />

      <aside
        className={`sidebar-container ${isOpen ? 'open' : ''}`}
        aria-hidden={!isOpen}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onTouchCancel={onTouchEnd}
      >
        <div className="sidebar-header">
          <Link to="/" onClick={toggleSidebar} className="sidebar-logo-link" aria-label="Home">
            <img src={pinLogo} alt="Edgar Lopez Law Firm" className="sidebar-logo" />
          </Link>

          <button className="close-btn" onClick={toggleSidebar} aria-label="Close menu">
            ×
          </button>
        </div>

        <nav className="sidebar-nav" aria-label="Sidebar navigation">
          <ul>
            <li>
              <Link to="/" onClick={toggleSidebar}>
                <span>Home</span>
              </Link>
            </li>

            <li>
              <Link to="/about" onClick={toggleSidebar}>
                <span>✪✪✪✪✪</span>
              </Link>
            </li>

            <li>
              <Link to="/flight-tracker" onClick={toggleSidebar}>
                <span>Case Results</span>
              </Link>
            </li>


            <li>
              <Link to="/contactus" onClick={toggleSidebar}>
                <span>Contact</span>
              </Link>
            </li>

            <li>
              <Link to="/dashboard" onClick={toggleSidebar}>
                <span>Login</span>
              </Link>
            </li>

            <li>
              <Link to="/quote" onClick={toggleSidebar}>
                <span>Free Consultation</span>
              </Link>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <small>
            <Link to="/terms" onClick={toggleSidebar}>
              <span>Terms of Use</span>
            </Link>
          </small>

          <small>
            <Link to="/privacy" onClick={toggleSidebar}>
              <span>Privacy Policy</span>
            </Link>
          </small>

          <small className="sidebar-disclaimer">
            No Attorney-Client Relationship Created By This Website.
          </small>
        </div>
      </aside>
    </>
  );
}

export default SideBar;